import React from "react";
import { useFormatter } from "hooks/intl";
import classNames from "classnames";
import {
  SchemaComponent,
  SchemaComponentInternalProps,
  useField,
  requiredValidator,
  BaseSchema,
} from "react-hook-schema-form";
import { FieldWrapper } from "./common/fieldWrapper";
import { DisplayComponent } from "./common/displayWrapper";
import { DateTimePickerStyled } from "components/DatePicker";

interface DateTimeSchema extends BaseSchema {
  schemaType: "datetime";
  required?: boolean;
}

const DateTimeSchemaComponent: SchemaComponent<DateTimeSchema> = (
  props: SchemaComponentInternalProps<DateTimeSchema>
) => {
  const { registerProps, value, fieldState } = useField(props, [
    requiredValidator,
  ]);
  return (
    <FieldWrapper fieldState={fieldState}>
      <DateTimePickerStyled
        className={classNames("form-control", {
          "has-error": fieldState.invalid,
        })}
        date={value ? new Date(value) : null}
        {...registerProps}
      />
    </FieldWrapper>
  );
};

DateTimeSchemaComponent.display = DisplayComponent(
  "DateTimeDisplayComponent",
  (value) => {
    const { formatDateTime } = useFormatter();
    return value ? formatDateTime(value) + "" : "";
  }
);

export default DateTimeSchemaComponent;
